// V2 Menu Entry Point
// =====================
// Carrega Stimulus.js e registra todos os controllers do v2 menu

import { Application } from '@hotwired/stimulus'

// Criar aplicação Stimulus
const application = Application.start()

// Importar controller diretamente
import MenuController from '../controllers/companies/v2/menu_controller'

// Registrar controller com o nome correto
application.register('companies--v2--menu', MenuController)

console.log('[VIPTable] Stimulus loaded, controller registered: companies--v2--menu')

// Exportar para testes ou uso externo se necessário
window.Stimulus = application
